import { Text } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";

export default function LandingPage() {
    Navigate({to: "/home"});
    return (
        <Text>
            LandingPage
        </Text>
    )
};